<template>
  <div class="select-option" ref="select-option">
    <transition name="fade">
      <div v-if="isVisible">
        <InputCheckbox
          v-if="checkbox"
          :value="value"
          :inputValue="inputValue"
          :label="label"
          :checked="isChecked"
          :class="{ disabled: disabled }"
          @change="handleEvent($event)"
        >
          <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="props">
            <slot v-bind="props" :name="slot" />
          </template>
        </InputCheckbox>

        <button
          v-else
          v-html="label"
          type="button"
          @click="handleEvent(inputValue)"
        ></button>
      </div>
    </transition>
  </div>
</template>

<script>
/** Componente que representa uma opção de uma lista de um select */
import InputCheckbox from '../InputCheckbox'

export default {
  name: 'SelectOption',

  components: {
    InputCheckbox
  },

  props: {
    inputValue: [String, Number, Object],
    value: [Array, Number, String, Object],
    /** Texto do input */
    label: {
      type: String,
      required: true
    },
    /** Se deve apresentar checkbox */
    checkbox: {
      type: Boolean,
      default: false
    },
    /** Se está desabilitado */
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isVisible: false
    }
  },

  computed: {
    isChecked() {
      return (
        this.value.findIndex(
          (item) => +item.codigo === +this.inputValue.codigo
        ) > -1
      )
    }
  },

  mounted() {
    this.startObserver()
  },

  methods: {
    /** Inicializa um observador para controlar a visibilidade do componente na lista */
    startObserver() {
      const observador = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            /** loop em todos os elementos atingidos */
            const { isIntersecting, intersectionRatio } = entry

            this.handleVisibility(isIntersecting || intersectionRatio > 0)
          })
        },
        {
          root:
            this.$refs['select-option'].closest('.select-options') ||
            this.$refs['select-option'].parentElement.parentElement
              .parentElement.parentElement,
          rootMargin: '50px'
        }
      )

      /** iniciando o observador para o componente */
      observador.observe(this.$refs['select-option'])
    },

    handleVisibility(isVisible) {
      this.isVisible = isVisible
    },

    /**
     * Manipula os eventos da opção
     * @param {object} value valor da opção
     */
    handleEvent(value) {
      this.$emit('input', value)

      if (this.checkbox) {
        this.$emit('change', value)
      } else {
        this.$emit('click', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-option {
  width: 320px;
  height: 14px;
  cursor: pointer;

  button {
    width: 100%;
    border: none;
    background: none;
    text-align: left;

    display: block;
    font-size: font-size('size-medium');
    font-weight: font-weight('weight-normal');
  }
}
</style>
